import React from "react";
import FacilitiesListSkeleton from "./skeleton/FacilitiesListSkeleton";
import FacilitiesItem from "./FacilitiesItem";
import ScrollContent from "components/UI/ScrollContent";

const FacilitiesList = ({ facilities, loading, click, select }) => {
  if (!facilities || loading) {
    return <FacilitiesListSkeleton />;
  }

  return (
    <ScrollContent mr={20}>
      <div className="row kiosk-row">
        {facilities.map((fa, i) => {
          return (
            <div className="col-6" key={fa.type}>
              <FacilitiesItem
                title={fa.title}
                icon={fa.icon}
                click={(event) => click(event, fa.type)}
                active={select === fa.type}
              />
            </div>
          );
        })}
      </div>
    </ScrollContent>
  );
};

export default FacilitiesList;
